import { useCallback, useEffect, useState } from 'react'

export const useFocusMode = () => {
  const [isFocusMode, setIsFocusMode] = useState(false)

  const toggleFocusMode = useCallback(() => {
    setIsFocusMode((prev) => !prev)
  }, [])

  // Exit focus mode on Escape key
  useEffect(() => {
    if (!isFocusMode) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setIsFocusMode(false)
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isFocusMode])

  return { isFocusMode, toggleFocusMode }
}
